/**
 * @file useExperienceDetail.hook.ts
 * @path apps/website/src/features/experiences/hooks/useExperienceDetail.hook.ts
 * @description Custom React hook
 */

import { useParams } from "react-router-dom";
import { useMemo } from "react";
import { ExperienceService } from "../experience.service";

export const useExperienceDetail = () => {
  const { slug } = useParams<{ slug: string }>();

  const data = useMemo(() => {
    return slug ? ExperienceService.getExperienceBySlug(slug) : null;
  }, [slug]);

  return {
    data,
    isNotFound: !data && !!slug,
  };
};
